import { Scorecard, ScorecardListItem } from 'store/interfaces';

export default function mergeScorecardListItemIntoFullData(
  scorecard: Scorecard,
  item: ScorecardListItem,
): Scorecard {
  const { goals, feedbacks, feedbackRequests, ...listData } =
    item as Partial<Scorecard>;

  return {
    ...scorecard,
    ...listData,
  };
}
